<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="popup _tcoins" @click="$emit('close')">
        <div class="popupInner" @click.stop>
            <btn-close @click="$emit('close')" />
            <div class="popup__body">
                <div class="popup__img">
                    <img :src="require(`@/assets/img/iftar/iftar-combo.png`)" alt="img" />
                </div>
                <h2 class="popup__title">{{ title }}</h2>
                <h3 class="popup__subtitle">{{ subtitle }}</h3>
                <div class="popup__message">
                    {{ message }}
                </div>
                <button class="btn" @click="setCategory()">Заказать доставку</button>
            </div>
        </div>
    </div>
</template>

<script>
import BtnClose from "../UI/BtnClose.vue";
export default {
    components: { BtnClose },
    props: ["title", "subtitle", "message", "img"],
    methods: {
        setCategory() {
            localStorage.setItem("nameCategory", "Ифтары");
            this.$router.push("/menu");
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.popup {
    &._tcoins {
        .btn-close {
            position: absolute;
            top: 15px;
            right: 15px;
            @media (max-width: 768px) {
                top: 25px;
                right: 25px;
            }
        }
        .popup__img {
            width: 100%;
            height: 162px;
            border-radius: 16px;
            overflow: hidden;
            img {
                object-fit: cover;
            }
            @media (max-width: 768px) {
                height: 145px;
            }
        }
        .popup__body {
            max-width: 384px;
            margin: 0 auto;
            padding: 10px 10px 35px;
            @media (max-width: 768px) {
                max-width: 100%;
                padding: 15px 15px 25px;
            }
        }
        .popup__title {
            font-size: 16px;
            margin-top: 20px;
            @media (max-width: 768px) {
                font-size: 14px;
                padding: 0 50px;
            }
        }
        .popup__message {
            font-size: 14px;
            color: #7a7a7a;
            margin-top: 10px;
            @media (max-width: 768px) {
                font-size: 12px;
            }
        }
        .btn {
            margin: 15px auto 0;
            font-family: "Nunito Sans Bold";
            width: fit-content;
            padding: 0 20px;
            @media (max-width: 768px) {
                padding: 0 35px;
            }
        }
    }
}
</style>
